import CityPageTemplate from "../city-template/CityPageTemplate";
import { scottsdaleConfig } from "./data";

export default function ScottsdalePage() {
  return <CityPageTemplate config={scottsdaleConfig} />;
}